import React from 'react'
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import aboutus from '../Assets/About_Img.png';
function Aboutus() {

  return (
    <Container fluid className='m-0 p-0' >

      <div style={{ backgroundColor: '#025EA9' }} className='m-0 p-4 header-bg text-center'>
        <Container>


          <h2 class="text-white pt-3">About Us</h2>



        </Container>

      </div>

      <Container>

        <div class="row mt-4">
          <div class=" col-md-4">
            <h2>Our Mission</h2>
            <p style={{ backgroundColor: '#EBF2F7', borderLeft: 'solid 8px #F37010', fontSize: '16px' }} className='p-5 fw-bold mt-2'>
              To revolutionize the pharmaceutical <br />
              industry by seamlessly integrating <br />
              AI-driven recruitment and innovative
              pharma solutions.

            </p>

            <h2>Our Vision</h2>
            <p style={{ backgroundColor: '#EBF2F7', borderLeft: 'solid 8px #F37010', fontSize: '16px' }} className='p-5 fw-bold mt-2'>
              To be the global leader in AI-powered <br />
              pharma staffing and R&D innovation.

            </p>

          </div>
          <div class=" col-md-8"> <img src={aboutus} alt='Employment Exchange' style={{ width: '80%' }} className='img-fluid' />  </div>
        </div>
        <h2>Core Values</h2>
        <Row className="g-3 mt-2  " > {/* 'g-3' adds spacing between columns */}
          <Col style={{ backgroundColor: '#EBF2F7', borderLeft: 'solid 8px #F37010', fontSize: '16px' }} className=" p-4  col" xs={12} sm={4}> {/* xs={12} makes it full width on small screens */}
            <h3 ><span style={{ color: '#F37010 ' }}>Innovation</span></h3>
            Leveraging AI for smarter <br />
            pharma solutions
          </Col>
          <Col style={{ backgroundColor: '#EBF2F7', borderLeft: 'solid 8px #F37010', fontSize: '16px' }} className=" p-4  col" xs={12} sm={4}> {/* xs={12} makes it full width on small screens */}
            <h3><span style={{ color: '#F37010 ' }}>Integrity</span></h3>
            Commitment to ethical <br />
            business practices
          </Col>
          <Col style={{ backgroundColor: '#EBF2F7', borderLeft: 'solid 8px #F37010', fontSize: '16px' }} className=" p-4  col" xs={12} sm={4}> {/* xs={12} makes it full width on small screens */}
            <h3><span style={{ color: '#F37010 ' }}>Excellence</span></h3>
            Delivering top-tier talent <br />
            and solutions
          </Col>
        </Row>
      </Container>
      <div style={{ backgroundColor: '#025EA9' }} className='pt-5 pb-5 howitsworks-header-bg mt-4'>
        <Container>
          <h2 className='fw-bold text-center text-white mt-4'>How It Works</h2>

          <div class="steps pb-5">
            <div id="progress"></div>
            <div class="step-item">
              <button class="step-button text-center" type="button" data-toggle="collapse"
                data-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                1
              </button>
              <div class="step-title">
                Sign Up & Create <br />Profile
              </div>
            </div>
            <div class="step-item">
              <button class="step-button text-center collapsed" type="button" data-toggle="collapse"
                data-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
                2
              </button>
              <div class="step-title">
                Post Jobs & <br />Requirements
              </div>
            </div>
            <div class="step-item">
              <button class="step-button text-center collapsed" type="button" data-toggle="collapse"
                data-target="#collapseThree" aria-expanded="false" aria-controls="collapseThree">
                3
              </button>
              <div class="step-title">
                Match with AI-Powered <br />Recommendations
              </div>
            </div>

            <div class="step-item">
              <button class="step-button text-center collapsed" type="button" data-toggle="collapse"
                data-target="#collapseThree" aria-expanded="false" aria-controls="collapseThree">
                4
              </button>
              <div class="step-title">
                Onboard Top-Tier <br />Pharma Talent
              </div>
            </div>


            <div class="step-item">
              <button class="step-button text-center collapsed" type="button" data-toggle="collapse"
                data-target="#collapseThree" aria-expanded="false" aria-controls="collapseThree">
                5
              </button>
              <div class="step-title">
                Scale Your Business <br />with AI Support
              </div>
            </div>
          </div>
        </Container>
      </div>
    </Container>

  );


}

export default Aboutus